import React from "react";
import MasterLayout from "../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../components/Breadcrumb";
import HowToWork from "./HowToWork";

const HowToWorkLayout = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="How to work" />
      <HowToWork />
    </MasterLayout>
  );
};

export default HowToWorkLayout;
